import { Actions as _Actions } from '@ngneat/effects';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class Actions extends _Actions {}
